import { useEffect, useState } from "react";

import useAxios from "@src/utility/hooks/use-axios";
import { useParams } from "react-router-dom";

const useTimeline = () => {
    const { platformId } = useParams();
    const { clientId } = useParams();
    const [data, setData] = useState({
        timelines : [],
        pagination: {}
    });
    const { axiosInstance, loading } = useAxios({ base: "panel", initialLoader: true });

    const getTimeline = async ({ page, limit }) => {
        const { data, pagination } = await axiosInstance.get(`/timelines/${platformId}`, {
            params: {
                page,
                limit,
                client_id: clientId
            }
        });
        setData({
            timelines: data.timelines,
            pagination
        });
    };
    const handlePageChange = (page) => {
        getTimeline({ page, limit: 10 });
    };

    const handleLimit = (limit) => {
        getTimeline({ page: 1, limit });
    };
    useEffect(() => {
        getTimeline({ page: 1, limit: 10 });                
    }, []);

    return {
        loading,
        data,
        getTimeline,
        handlePageChange,
        handleLimit
    };
};

export default useTimeline;